import styled from 'styled-components';

import * as mixin from '@wconcept/wconcept-ui-renewal/styles/mixin';

export const NoticeModal = styled.div`
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
  background-color: #fff;
  max-height: calc(-50px + 100vh);
  height: 100%;
  border-radius: 20px 20px 0 0;
  overflow: hidden;
  overflow-y: auto;

  .content {
    padding: 24px 20px;

    .desc {
      color: #555;
      text-align: center;
      font-size: 16px;
      line-height: 130%;
    }
  }

  &.btn-type-single .modal-group-btn {
    border-top: 1px solid #eee;

    .btn {
      color: #000;
      background: #fff;
      border: 1px solid #000;
    }
  }

  @media ${({ theme }) => theme.media.smMax} {
    border-radius: ${mixin.pxToVw('20 20 0 0')};

    .content {
      padding: ${mixin.pxToVw('24 20')};

      .desc {
        font-size: ${mixin.pxToVw('16')};
      }
    }
  }

  @media ${({ theme }) => theme.media.pc} {
    width: 450px;
    padding-top: 56px;
    border-radius: 0;

    .content {
      padding: 6px 32px;

      .desc {
        font-size: 18px;
      }
    }

    .modal-close-btn {
      position: absolute;
      top: 12px;
      right: 12px;
    }

    .modal-group-btn {
      padding: 32px;
    }

    &.btn-type-single .modal-group-btn {
      border: none;
      justify-content: center;

      .btn {
        border-color: #e2e2e2;
      }
    }
  }
`;
